// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hub-tournament-card {
    background: var(--white-color);
    box-shadow: 0px 3.28811px 3.28811px rgba(170, 193, 182, 0.32);
    border-radius: 12px;
    margin: 0;
    min-width: 22rem;
}

.hub-tournament-card.hub-cursor{
    cursor: pointer;
}

.hub-tournament-card.long-view {
    min-width: 584px;
    padding: 12px;
}

.hub-tournament-card__img-container{
    height: 190px;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;    
    flex-direction: column;
    position: relative;
}
.hub-tournament-card__img-container .icon-trophy{
    font-size: 34px;
    color: var(--white-color);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px 12px 0 0;
}

.hub-tournament-card__container.long-view {
    display: flex;
}

.hub-tournament-card__img-container.long-view {
    border-radius: 7px;
    width: 240px;
    height: 130px;
}

.hub-tournament-card__img-container.follow-view {
    display: none;
}

.hub-tournament-card__tournament-photo{
    height: 100%;
    width: 100%;
    border-radius: 12px 12px 0 0;
}

.hub-tournament-card__tournament-photo.long-view{
    height: 130px;
    width: 240px;
    border-radius: 7px;
    object-fit: cover;
}

.hub-tournament-card__tournament-data{
    padding: var(--space);
}

.hub-tournament-card__tournament-data.long-view {
    padding: 0;
    margin: 0 12px;
}

.hub-tournament-card__tournament-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.hub-tournament-card__tournament-info__name.baloa-names{
    color: var(--primary-dark-color);

    width: 275px;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    white-space: pre-wrap;
    display: inline-block;
}

.hub-tournament-card__tournament-info__img {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 7px;
    aspect-ratio: 1;
}

.hub-tournament-card__tournament-info__img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.hub-tournament-card__tournament-info__img .icon-ball {
    font-size: 28px;
    border-radius: 50%;
    padding: 4px;
    color: var(--white-color);
}

.hub-tournament-card__tournament-tags{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    margin-top: 10px;
    flex-wrap: wrap;
}

.hub-tournament-card__tournament-tags__tag.baloa-username{
    background: var(--new-grey-light-background-color);
    border-radius: var(--space-and-half);
    color: var(--primary-dark-color);
    padding: 4px 6px;
    margin-right: var(--space-quarter);
    font-size: 15px;
    line-height: var(--space-half-quarter);
    border: 1px solid var(--new-grey-border-color);
    margin-top: 6px;
}

.hub-tournament-card__tournament-dates{
    margin-top: var(--space);
}

.hub-tournament-card__tournament-dates.baloa-username{
    color: var(--primary-dark-color);
}

.hub-tournament-card__tournament-location{
    margin-top: var(--space-half);
}
.hub-tournament-card__tournament-location.baloa-username{
    color: var(--primary-dark-color);
}

.hub-tournament-card__buttons{
    display: flex;
    justify-content: space-between;
    padding: 3px 14px 14px 14px;
}

.hub-tournament-card__buttons__btn-more{
    width: 100%;
}

.hub-tournament-card__buttons .secondary-button{
    padding: calc(var(--space-half) + var(--space-eighth)) var(--space-and-half);
    margin-left: 10px;
}

.hub-tournament-card__buttons__btn-50.small {
    width: 48%;
    padding: calc(var(--space-half) + var(--space-eighth)) 30px
}

.hub-tournament-card__card-team-label {
    background: rgba(0, 0, 0, 0.75);
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: var(--space-half);
}

.hub-tournament-card__card-team-label__img {
    width: var(--space);
    height: var(--space);
    display: flex;
    align-items: center;
    justify-content: center;
}

.hub-tournament-card__card-team-label__img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.hub-tournament-card__card-team-label__img .icon-ball {
    font-size: 12px;
    border-radius: 50%;
    padding: 2px;
    color: var(--white-color);
}

.hub-tournament-card__card-team-label .baloa-table-column {
    color: var(--white-color);
    margin-left: var(--space-half);
}

.hub-tournament-card__labels-container {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: flex-start;
    height: 100%;
    padding: 8px;
}

.hub-tournament-card__labels-container.tournament-participate,
.hub-tournament-card__labels-container.tournament-follow,
.hub-tournament-card__labels-container.tournament-admin,
.hub-tournament-card__labels-container.registration-open,
.hub-tournament-card__labels-container.in-progress {
    
    align-items: flex-end;
    
}


.hub-tournament-card__labels-container.tournament-participate,
.hub-tournament-card__labels-container.tournament-follow,
.hub-tournament-card__labels-container.tournament-admin,
.hub-tournament-card__labels-container.registration-open,
.hub-tournament-card__labels-container.in-progress {
    
    align-items: flex-end;
    
}

.hub-tournament-card__labels-container__tournament-pending {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    height: 100%;
}

.hub-tournament-card__labels-container__tournament-participate,
.hub-tournament-card__labels-container__tournament-follow,
.hub-tournament-card__labels-container__tournament-admin,
.hub-tournament-card__labels-container__tournament-registration-open,
.hub-tournament-card__labels-container__tournament-in-progress,
.hub-tournament-card__labels-container__tournament-finalized {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    height: 100%;
}

.hub-tournament-card__labels-container .baloa-table-column{
    padding: 5px 10px;
    border-radius: 4px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    color: var(--white-color);
}

.hub-tournament-card__labels-container .registration-open {
    background-color: #3078B3;
}

.hub-tournament-card__labels-container .scheduled {
    background-color: var(--new-green-color);
}

.hub-tournament-card__labels-container .finalized {
    background-color: var(--basic-gray-color);
}

.hub-tournament-card__labels-container .enrolled {
    background-color: #9747FF;
}

.hub-tournament-card__labels-container .to_finalize {
    background-color: var(--error-color);
}

.hub-tournament-card__labels__team {
    position: absolute;
    display: flex;
    align-items: center;
    width: 100%;
    background: rgba(0, 0, 0, 0.75);
    padding: 8px;
    bottom: 0;
}

.hub-tournament-card__labels__team .baloa-table-column {
    color: var(--white-color);
    margin-left: 8px;
}

button.button.primary-button.hub-tournament-card__buttons__btn-50.small.grey-btn {
    background-color: var(--basic-gray-color);
}

.hub-tournament-card__tournament-page {
    display: flex;
    align-items: center;
    margin-top: 12px;
}

.hub-tournament-card__tournament-page img {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 4px;
}

.hub-tournament-card__tournament-page .icon-ball {
    font-size: 16px;
    border-radius: 50%;
    padding: 3px;
    color: var(--white-color);
    margin-right: 4px; 
}

.hub-tournament-card__tournament-page.baloa-username{
    color: var(--primary-dark-color);
    margin: 0;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    .hub-tournament-card__container {
        display: flex;
        padding: var(--space-half);
    }

    .hub-tournament-card__img-container {
        height: unset;
        border-radius: var(--space);
        justify-content: flex-start;
        /* width: 35%; */
        width: fit-content;
    }

    .hub-tournament-card__tournament-photo {
        width: 120px;
        height: 79px;
        border-radius: 4px;
        object-fit: cover;
    }

    .hub-tournament-card__card-team-label {
        background: unset;
        position: relative;
    }

    .hub-tournament-card__card-team-label .baloa-table-column {
        color: var(--primary-very-dark-colo);
       
    }

    .hub-tournament-card__card-team-label__img .icon-ball {
        font-size: 14px;
    }
    
    .hub-tournament-card__card-team-label__img {
        width: var(--space-and-half);
        height: var(--space-and-half);
    }    

    .hub-tournament-card__tournament-data {
        padding: unset;
        padding-left: 8px;
    }

    .hub-tournament-card__card-team-label {
        width: unset;
    }

    .hub-tournament-card__tournament-data__container {
        width: 65%;
        
        /* padding-left: 8px; */
    }

    .hub-tournament-card__container.long-view .hub-tournament-card__tournament-data__container,
    .hub-tournament-card__container.follow-view .hub-tournament-card__tournament-data__container {
        width: 100%;
    }

    .hub-tournament-card {
        margin: 8px 8px;
        border-radius: 4px;
    }

    .hub-tournament-card__tournament-info.baloa-truncate {
        width: 100%;
    }
    .hub-tournament-card__buttons {
        justify-content: flex-end;
        margin-top: 10px;
        padding: 0;
    }
    
    .hub-tournament-card__buttons__btn-50{
        width: 60%;
        justify-content: center;
    }

    .hub-tournament-card__labels-container {
        flex-direction: column;
        height: 79px;
        justify-content: flex-end;
        top: 0;
    }

    .hub-tournament-card__labels__team {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        background: none;
        padding: 0;
        margin-top: 10px;
        max-width: 120px;
    }

    .hub-tournament-card__labels__team .baloa-table-column,
    .hub-tournament-card__card-team-label .baloa-table-column {
        color: var(--primary-very-dark-color);
    }

    .hub-tournament-card__labels-container__tournament-pending,
    .hub-tournament-card__labels-container__tournament-participate,
    .hub-tournament-card__labels-container__tournament-admin{
        flex-direction: column;
        align-items: flex-start;
    }

    .hub-tournament-card__card-team-label__img .icon-ball {
        font-size: 14px;
    }

    .hub-tournament-card__tournament-tags__tag.baloa-username{
        width: auto;
        padding: 2px 4px;
        font-size: 10px;
    }

    .hub-tournament-card__tournament-info__img {
        width: 28px;
        height: 28px;
        min-width: 28px;
        min-height: 28px;
        border-radius: 50%;
    }

    .hub-tournament-card__tournament-tags, 
    .hub-tournament-card__tournament-location,
    .hub-tournament-card__tournament-page {
        margin-top: 4px;
    }

    .hub-tournament-card__tournament-page .icon-ball {
        font-size: 8px;
        padding: 2px;
    }

    .hub-tournament-card__tournament-page img {
        width: 12px;
        height: 12px;
    }

    .hub-tournament-card.long-view{
        width: 181px;
        min-width: 181px;
        padding: 0;
    }

    .hub-tournament-card__container.long-view {
        display: inline;
        max-width: 181px;
        padding: 0;
    }

    .hub-tournament-card__img-container.long-view{
        width: 181px;
        height: 89px;
        object-fit: cover;
    }

    .hub-tournament-card__tournament-photo.long-view {
        width: 181px;
        height: 89px;
        border-radius: 7px 7px 0 0;
    }

    .hub-tournament-card__tournament-data.long-view {
        width: 100%;
        margin: 8px 0;
        padding-left: 8px;
    }

    .hub-tournament-card__tournament-data.long-view .hub-tournament-card__tournament-info.baloa-truncate {
        white-space: normal;
    }

    .hub-tournament-card.follow-view {
        width: 176px;
        min-width: 176px;
        margin: 0;
    }

    .hub-tournament-card__tournament-data.follow-view {
        padding: 0;
    }
}




`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/hub-tournament-card/HubTournamentCardComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,6DAA6D;IAC7D,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;;IAEhC,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,oCAAoC;IACpC,gCAAgC;IAChC,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,sCAAsC;IACtC,8CAA8C;IAC9C,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4EAA4E;IAC5E,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;;AAEA;;;;;;IAMI,qBAAqB;;AAEzB;;;AAGA;;;;;;IAMI,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;;IAMI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,+BAA+B;IAC/B,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,SAAS;AACb;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,aAAa;QACb,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,2BAA2B;QAC3B,2BAA2B;QAC3B,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,oCAAoC;;IAExC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;;QAEV,uBAAuB;IAC3B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,UAAU;QACV,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,yBAAyB;QACzB,MAAM;IACV;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,qCAAqC;IACzC;;IAEA;;;QAGI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".hub-tournament-card {\n    background: var(--white-color);\n    box-shadow: 0px 3.28811px 3.28811px rgba(170, 193, 182, 0.32);\n    border-radius: 12px;\n    margin: 0;\n    min-width: 22rem;\n}\n\n.hub-tournament-card.hub-cursor{\n    cursor: pointer;\n}\n\n.hub-tournament-card.long-view {\n    min-width: 584px;\n    padding: 12px;\n}\n\n.hub-tournament-card__img-container{\n    height: 190px;\n    border-radius: 12px 12px 0 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;    \n    flex-direction: column;\n    position: relative;\n}\n.hub-tournament-card__img-container .icon-trophy{\n    font-size: 34px;\n    color: var(--white-color);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px 12px 0 0;\n}\n\n.hub-tournament-card__container.long-view {\n    display: flex;\n}\n\n.hub-tournament-card__img-container.long-view {\n    border-radius: 7px;\n    width: 240px;\n    height: 130px;\n}\n\n.hub-tournament-card__img-container.follow-view {\n    display: none;\n}\n\n.hub-tournament-card__tournament-photo{\n    height: 100%;\n    width: 100%;\n    border-radius: 12px 12px 0 0;\n}\n\n.hub-tournament-card__tournament-photo.long-view{\n    height: 130px;\n    width: 240px;\n    border-radius: 7px;\n    object-fit: cover;\n}\n\n.hub-tournament-card__tournament-data{\n    padding: var(--space);\n}\n\n.hub-tournament-card__tournament-data.long-view {\n    padding: 0;\n    margin: 0 12px;\n}\n\n.hub-tournament-card__tournament-info {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.hub-tournament-card__tournament-info__name.baloa-names{\n    color: var(--primary-dark-color);\n\n    width: 275px;\n    overflow: hidden;\n    /* text-overflow: ellipsis; */\n    white-space: pre-wrap;\n    display: inline-block;\n}\n\n.hub-tournament-card__tournament-info__img {\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 7px;\n    aspect-ratio: 1;\n}\n\n.hub-tournament-card__tournament-info__img img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n\n.hub-tournament-card__tournament-info__img .icon-ball {\n    font-size: 28px;\n    border-radius: 50%;\n    padding: 4px;\n    color: var(--white-color);\n}\n\n.hub-tournament-card__tournament-tags{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 11px;\n    line-height: 13px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    margin-top: 10px;\n    flex-wrap: wrap;\n}\n\n.hub-tournament-card__tournament-tags__tag.baloa-username{\n    background: var(--new-grey-light-background-color);\n    border-radius: var(--space-and-half);\n    color: var(--primary-dark-color);\n    padding: 4px 6px;\n    margin-right: var(--space-quarter);\n    font-size: 15px;\n    line-height: var(--space-half-quarter);\n    border: 1px solid var(--new-grey-border-color);\n    margin-top: 6px;\n}\n\n.hub-tournament-card__tournament-dates{\n    margin-top: var(--space);\n}\n\n.hub-tournament-card__tournament-dates.baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.hub-tournament-card__tournament-location{\n    margin-top: var(--space-half);\n}\n.hub-tournament-card__tournament-location.baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.hub-tournament-card__buttons{\n    display: flex;\n    justify-content: space-between;\n    padding: 3px 14px 14px 14px;\n}\n\n.hub-tournament-card__buttons__btn-more{\n    width: 100%;\n}\n\n.hub-tournament-card__buttons .secondary-button{\n    padding: calc(var(--space-half) + var(--space-eighth)) var(--space-and-half);\n    margin-left: 10px;\n}\n\n.hub-tournament-card__buttons__btn-50.small {\n    width: 48%;\n    padding: calc(var(--space-half) + var(--space-eighth)) 30px\n}\n\n.hub-tournament-card__card-team-label {\n    background: rgba(0, 0, 0, 0.75);\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: var(--space-half);\n}\n\n.hub-tournament-card__card-team-label__img {\n    width: var(--space);\n    height: var(--space);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.hub-tournament-card__card-team-label__img img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n}\n\n.hub-tournament-card__card-team-label__img .icon-ball {\n    font-size: 12px;\n    border-radius: 50%;\n    padding: 2px;\n    color: var(--white-color);\n}\n\n.hub-tournament-card__card-team-label .baloa-table-column {\n    color: var(--white-color);\n    margin-left: var(--space-half);\n}\n\n.hub-tournament-card__labels-container {\n    position: absolute;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: flex-start;\n    height: 100%;\n    padding: 8px;\n}\n\n.hub-tournament-card__labels-container.tournament-participate,\n.hub-tournament-card__labels-container.tournament-follow,\n.hub-tournament-card__labels-container.tournament-admin,\n.hub-tournament-card__labels-container.registration-open,\n.hub-tournament-card__labels-container.in-progress {\n    \n    align-items: flex-end;\n    \n}\n\n\n.hub-tournament-card__labels-container.tournament-participate,\n.hub-tournament-card__labels-container.tournament-follow,\n.hub-tournament-card__labels-container.tournament-admin,\n.hub-tournament-card__labels-container.registration-open,\n.hub-tournament-card__labels-container.in-progress {\n    \n    align-items: flex-end;\n    \n}\n\n.hub-tournament-card__labels-container__tournament-pending {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n}\n\n.hub-tournament-card__labels-container__tournament-participate,\n.hub-tournament-card__labels-container__tournament-follow,\n.hub-tournament-card__labels-container__tournament-admin,\n.hub-tournament-card__labels-container__tournament-registration-open,\n.hub-tournament-card__labels-container__tournament-in-progress,\n.hub-tournament-card__labels-container__tournament-finalized {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n}\n\n.hub-tournament-card__labels-container .baloa-table-column{\n    padding: 5px 10px;\n    border-radius: 4px;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);\n    color: var(--white-color);\n}\n\n.hub-tournament-card__labels-container .registration-open {\n    background-color: #3078B3;\n}\n\n.hub-tournament-card__labels-container .scheduled {\n    background-color: var(--new-green-color);\n}\n\n.hub-tournament-card__labels-container .finalized {\n    background-color: var(--basic-gray-color);\n}\n\n.hub-tournament-card__labels-container .enrolled {\n    background-color: #9747FF;\n}\n\n.hub-tournament-card__labels-container .to_finalize {\n    background-color: var(--error-color);\n}\n\n.hub-tournament-card__labels__team {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.75);\n    padding: 8px;\n    bottom: 0;\n}\n\n.hub-tournament-card__labels__team .baloa-table-column {\n    color: var(--white-color);\n    margin-left: 8px;\n}\n\nbutton.button.primary-button.hub-tournament-card__buttons__btn-50.small.grey-btn {\n    background-color: var(--basic-gray-color);\n}\n\n.hub-tournament-card__tournament-page {\n    display: flex;\n    align-items: center;\n    margin-top: 12px;\n}\n\n.hub-tournament-card__tournament-page img {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    margin-right: 4px;\n}\n\n.hub-tournament-card__tournament-page .icon-ball {\n    font-size: 16px;\n    border-radius: 50%;\n    padding: 3px;\n    color: var(--white-color);\n    margin-right: 4px; \n}\n\n.hub-tournament-card__tournament-page.baloa-username{\n    color: var(--primary-dark-color);\n    margin: 0;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    .hub-tournament-card__container {\n        display: flex;\n        padding: var(--space-half);\n    }\n\n    .hub-tournament-card__img-container {\n        height: unset;\n        border-radius: var(--space);\n        justify-content: flex-start;\n        /* width: 35%; */\n        width: fit-content;\n    }\n\n    .hub-tournament-card__tournament-photo {\n        width: 120px;\n        height: 79px;\n        border-radius: 4px;\n        object-fit: cover;\n    }\n\n    .hub-tournament-card__card-team-label {\n        background: unset;\n        position: relative;\n    }\n\n    .hub-tournament-card__card-team-label .baloa-table-column {\n        color: var(--primary-very-dark-colo);\n       \n    }\n\n    .hub-tournament-card__card-team-label__img .icon-ball {\n        font-size: 14px;\n    }\n    \n    .hub-tournament-card__card-team-label__img {\n        width: var(--space-and-half);\n        height: var(--space-and-half);\n    }    \n\n    .hub-tournament-card__tournament-data {\n        padding: unset;\n        padding-left: 8px;\n    }\n\n    .hub-tournament-card__card-team-label {\n        width: unset;\n    }\n\n    .hub-tournament-card__tournament-data__container {\n        width: 65%;\n        \n        /* padding-left: 8px; */\n    }\n\n    .hub-tournament-card__container.long-view .hub-tournament-card__tournament-data__container,\n    .hub-tournament-card__container.follow-view .hub-tournament-card__tournament-data__container {\n        width: 100%;\n    }\n\n    .hub-tournament-card {\n        margin: 8px 8px;\n        border-radius: 4px;\n    }\n\n    .hub-tournament-card__tournament-info.baloa-truncate {\n        width: 100%;\n    }\n    .hub-tournament-card__buttons {\n        justify-content: flex-end;\n        margin-top: 10px;\n        padding: 0;\n    }\n    \n    .hub-tournament-card__buttons__btn-50{\n        width: 60%;\n        justify-content: center;\n    }\n\n    .hub-tournament-card__labels-container {\n        flex-direction: column;\n        height: 79px;\n        justify-content: flex-end;\n        top: 0;\n    }\n\n    .hub-tournament-card__labels__team {\n        position: relative;\n        display: flex;\n        align-items: center;\n        width: 100%;\n        background: none;\n        padding: 0;\n        margin-top: 10px;\n        max-width: 120px;\n    }\n\n    .hub-tournament-card__labels__team .baloa-table-column,\n    .hub-tournament-card__card-team-label .baloa-table-column {\n        color: var(--primary-very-dark-color);\n    }\n\n    .hub-tournament-card__labels-container__tournament-pending,\n    .hub-tournament-card__labels-container__tournament-participate,\n    .hub-tournament-card__labels-container__tournament-admin{\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .hub-tournament-card__card-team-label__img .icon-ball {\n        font-size: 14px;\n    }\n\n    .hub-tournament-card__tournament-tags__tag.baloa-username{\n        width: auto;\n        padding: 2px 4px;\n        font-size: 10px;\n    }\n\n    .hub-tournament-card__tournament-info__img {\n        width: 28px;\n        height: 28px;\n        min-width: 28px;\n        min-height: 28px;\n        border-radius: 50%;\n    }\n\n    .hub-tournament-card__tournament-tags, \n    .hub-tournament-card__tournament-location,\n    .hub-tournament-card__tournament-page {\n        margin-top: 4px;\n    }\n\n    .hub-tournament-card__tournament-page .icon-ball {\n        font-size: 8px;\n        padding: 2px;\n    }\n\n    .hub-tournament-card__tournament-page img {\n        width: 12px;\n        height: 12px;\n    }\n\n    .hub-tournament-card.long-view{\n        width: 181px;\n        min-width: 181px;\n        padding: 0;\n    }\n\n    .hub-tournament-card__container.long-view {\n        display: inline;\n        max-width: 181px;\n        padding: 0;\n    }\n\n    .hub-tournament-card__img-container.long-view{\n        width: 181px;\n        height: 89px;\n        object-fit: cover;\n    }\n\n    .hub-tournament-card__tournament-photo.long-view {\n        width: 181px;\n        height: 89px;\n        border-radius: 7px 7px 0 0;\n    }\n\n    .hub-tournament-card__tournament-data.long-view {\n        width: 100%;\n        margin: 8px 0;\n        padding-left: 8px;\n    }\n\n    .hub-tournament-card__tournament-data.long-view .hub-tournament-card__tournament-info.baloa-truncate {\n        white-space: normal;\n    }\n\n    .hub-tournament-card.follow-view {\n        width: 176px;\n        min-width: 176px;\n        margin: 0;\n    }\n\n    .hub-tournament-card__tournament-data.follow-view {\n        padding: 0;\n    }\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
